/**
 * EmployeeDailyData model translations
 *
 * Translation keys follow the pattern: models.employee_daily_data.{category}.{key}
 * Categories: fields, tabs, blocks, badges, actions, filters, options
 */
export default {
  en: {
    singular: "Daily Data",
    plural: "Daily Data",

    tabs: {
      general: "General",
      hours: "Hours",
      expenses: "Expenses",
      punch: "Punch Tracking",
      notes: "Notes",
    },

    blocks: {
      hours: "Hours",
      hours_adjustment: "Hours Adjustment",
      expenses: "Expenses",
      punch: "Punch Information",
      notes: "Notes",
      settings: "Settings",
    },

    fields: {
      user_id: "Employee",
      date: "Date",
      hours_adjustment: "Hours Adjustment",
      admin_hours: "Admin Hours",
      sick_hours: "Sick Hours",
      expenses: "Expenses",
      start_time_override: "Start Time Override",
      punched_at: "Punched At",
      punched_by_user_id: "Punched By",
      punch_canceled_at: "Punch Canceled At",
      punch_canceled_by_user_id: "Canceled By",
      notes: "Notes",
      disable_auto_admin_hours: "Disable Auto Admin Hours",
      created_at: "Created At",
      updated_at: "Updated At",
    },

    badges: {
      punched: "Punched",
      not_punched: "Not Punched",
      punch_canceled: "Canceled",
      true: "Yes",
      false: "No",
    },

    options: {
      expense_type: {
        mileage: "Mileage",
        meal: "Meal",
        parking: "Parking",
        other: "Other",
      },
    },

    filters: {
      user_id: "Employee",
      date: "Date",
    },
  },

  fr: {
    singular: "Donnees quotidiennes",
    plural: "Donnees quotidiennes",

    tabs: {
      general: "General",
      hours: "Heures",
      expenses: "Depenses",
      punch: "Suivi des punchs",
      notes: "Notes",
    },

    blocks: {
      hours: "Heures",
      hours_adjustment: "Ajustement des heures",
      expenses: "Depenses",
      punch: "Informations de punch",
      notes: "Notes",
      settings: "Parametres",
    },

    fields: {
      user_id: "Employe",
      date: "Date",
      hours_adjustment: "Ajustement des heures",
      admin_hours: "Heures admin",
      sick_hours: "Heures maladie",
      expenses: "Depenses",
      start_time_override: "Heure de debut (manuel)",
      punched_at: "Pointe a",
      punched_by_user_id: "Pointe par",
      punch_canceled_at: "Punch annule a",
      punch_canceled_by_user_id: "Annule par",
      notes: "Notes",
      disable_auto_admin_hours: "Desactiver heures admin auto",
      created_at: "Cree le",
      updated_at: "Modifie le",
    },

    badges: {
      punched: "Pointe",
      not_punched: "Non pointe",
      punch_canceled: "Annule",
      true: "Oui",
      false: "Non",
    },

    options: {
      expense_type: {
        mileage: "Kilometrage",
        meal: "Repas",
        parking: "Stationnement",
        other: "Autre",
      },
    },

    filters: {
      user_id: "Employe",
      date: "Date",
    },
  },
};
